import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["columnData"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ColumnIcon = _ref => {
  let {
      columnData
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    icon
  } = columnData;
  if (!icon) {
    return null;
  }
  const {
    IconComponent
  } = icon;
  if (!IconComponent) {
    console.error('IconComponent is required when useReskin is true. Please provide an icon from foundations-assets!');
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: icon.tooltip,
    disabled: !icon.tooltip,
    placement: "bottom",
    children: /*#__PURE__*/_jsx(IconButton, Object.assign({
      size: "xs",
      use: "unstyled"
    }, rest, {
      children: /*#__PURE__*/_jsx(IconComponent, {
        color: "icon-core-subtle"
      })
    }))
  });
};
export default ColumnIcon;